import _ from 'lodash';
import monarch from '../common/clients/monarch';

const initialState = {};
const RECEIVE = 'appliance/RECEIVE';

export function requestAppliance(applianceId) {
  return monarch
    .get(`/v1/qs/appliances/${applianceId}`)
    .then((response) => response.data);
}

export function receiveAppliance(appliance) {
  return { type: RECEIVE, payload: appliance };
}

export function loadAppliance(applianceId) {
  return (dispatch) => {
    return requestAppliance(applianceId).then((appliance) =>
      dispatch(receiveAppliance(appliance)),
    );
  };
}

export default function reducer(state = initialState, action) {
  let { type, payload } = action;
  switch (type) {
    case RECEIVE:
      return Object.assign({}, initialState, payload);

    default:
      return state;
  }
}
